import type { ReportBlock } from "../api/types";

/**
 * Split a block list into pages on `pageBreak` boundaries. Presentation mode
 * steps through these pages; the PDF renders one printed page each. The
 * pageBreak block itself is dropped. Empty leading/trailing pages are kept out.
 */
export const splitIntoPages = (blocks: ReportBlock[]): ReportBlock[][] => {
  const pages: ReportBlock[][] = [[]];
  for (const block of blocks) {
    if (block.type === "pageBreak") {
      pages.push([]);
      continue;
    }
    pages[pages.length - 1].push(block);
  }
  return pages.filter((page) => page.length > 0);
};
